module.exports = {
    tag: 'scrubbed',
    quality: 0.4,
    learning: 2,
    perception: 2,
};